import { ICON } from '../../config/icons';
import { useIsReadOnly } from '../../context/UserContextProvider';

import './DataCard.scss';

interface DataCardProps {
  icon?: keyof typeof ICON; // icons
  label: string;
  customLabel?: string;
  children?: React.ReactNode;
  callBackAction?: () => void;
  callBackLabel?: string;
  customClass?: string;
}

export const DataCard = ({
  icon,
  label,
  customLabel,
  children,
  callBackAction,
  callBackLabel = 'modify',
  customClass,
}: DataCardProps) => {
  const isReadOnly = useIsReadOnly();
  return (
    <div className={`data-card ${customClass || ''}`}>
      {icon && (
        <div className="icon">
          <img src={icon} alt={label} />
        </div>
      )}

      <div className="content">
        <div className="label">{customLabel || label}</div>
        {children && <div className="details">{children}</div>}
      </div>

      {callBackAction && (
        <div
          className={`more-link ${isReadOnly ? 'disabled' : ''}`}
          onClick={isReadOnly ? undefined : callBackAction}
        >
          {callBackLabel}
        </div>
      )}
    </div>
  );
};
